import { NextPageContext, NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/international-network.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';
import Hero from '../components/Hero';
import redirectToDomain from '../lib/redirectToDomain';
import { getTargetOrigin } from '../lib/redirectRouteToDomain';
import getWindowUrl from '../lib/getWindowUrl.mjs';
import getUrlFromRequest from '../lib/getUrlFromRequest.mjs';
import getOriginWithPrefix from '../lib/getOrigin';
import Markdown from '../components/Markdown';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/hXVDgIKqdV5kZly_wetq8040Rr16C2lXwpmUdMAOhaU/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvSGVhZGVyX2ltYWdlX2ludGVybmF0aW9uYWxuZXR3b3JrLnBuZw',
    'https://r.fashionunited.com/rNAg3UQUvKIJKxOIyyKhXeXk8-TBBpkLoMHly8jCYA4/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvSGVhZGVyX2ltYWdlX2ludGVybmF0aW9uYWxuZXR3b3JrLnBuZw',
    'https://r.fashionunited.com/1rxbEflBz4o8852l_v7PK2ZAseC9utyTGDlCbTwNQ20/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvSGVhZGVyX2ltYWdlX2ludGVybmF0aW9uYWxuZXR3b3JrLnBuZw',
  ],
  desktop: [
    'https://r.fashionunited.com/sH-UDUF0vMtMMEOuNGsaoWIUFiD7HCx9feCgDwqB78U/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvSGVhZGVyX2ltYWdlX2ludGVybmF0aW9uYWxuZXR3b3JrLnBuZw',
    'https://r.fashionunited.com/ngfSkoIouGtdk3N6jypmppEOlMF3Hbw-0JJeV-EChCk/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvSGVhZGVyX2ltYWdlX2ludGVybmF0aW9uYWxuZXR3b3JrLnBuZw',
    'https://r.fashionunited.com/niz_lA4_gcrs2-9jERh4DCzgrVFRM79yoZ3NaBnppBE/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvSGVhZGVyX2ltYWdlX2ludGVybmF0aW9uYWxuZXR3b3JrLnBuZw',
    'https://r.fashionunited.com/0vRuUuprNG02bKssvY-zPe60--XoNDO5UcqaYvGgL30/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvSGVhZGVyX2ltYWdlX2ludGVybmF0aW9uYWxuZXR3b3JrLnBuZw',
  ],
};

const bottomImageUrls = {
  mobile: [
    'https://r.fashionunited.com/4dCKHlR22SAi0ihWST8WSoyjvHVHrG0T8HbnQJpc_rk/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9JbnRlcm5hdGlvbmFsX05ldHdvcmsucG5n',
    'https://r.fashionunited.com/Ech8ApUK_KN0-ulgbH47lT5gVb_2ffMDY3nD78QbeXw/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9JbnRlcm5hdGlvbmFsX05ldHdvcmsucG5n',
    'https://r.fashionunited.com/SWNBboxZVY7fWtGJsoc_-LY2zg_7qIlFNbBlKpfKDek/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9JbnRlcm5hdGlvbmFsX05ldHdvcmsucG5n',
  ],
  desktop: [
    'https://r.fashionunited.com/VAv0sXd_BKTOgQDK_rkCI3aN6itCKx4KAPHa67bwn1Q/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9JbnRlcm5hdGlvbmFsX05ldHdvcmsucG5n',
    'https://r.fashionunited.com/8MNpFYb8mywkBANVD8_Aizg5Kb-LWZk5baZei7jBK38/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9JbnRlcm5hdGlvbmFsX05ldHdvcmsucG5n',
    'https://r.fashionunited.com/RFF5UZo9a9lc36hZGYREdsTq7hqwGpHPCaBbLLVMhus/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9JbnRlcm5hdGlvbmFsX05ldHdvcmsucG5n',
    'https://r.fashionunited.com/dV6-F-QSPHeQ6-w7Q2qxX7al8aLhb2YajrYYTTbJddE/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9JbnRlcm5hdGlvbmFsX05ldHdvcmsucG5n',
  ],
};

const InternationalNetworkPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="international-network"
      passHref
    >
      {intl.formatMessage(messages['internationalNetwork.title'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['internationalNetwork.title'])}
        description={intl.formatMessage(
          messages['internationalNetwork.title'],
        )}
      />
      <StaticPageComponent
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages['internationalNetwork.title'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

InternationalNetworkPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        imageUrls={headerImageUrls}
        alt="FashionUnited business cases"
      />
    )}
    bottomImage={(
      <Hero
        imageUrls={bottomImageUrls}
        alt="Countries where FashionUnited is active"
      />
    )}
  >
    {page}
  </Layout>
);

InternationalNetworkPage.getInitialProps = async (context: NextPageContext) => {
  const { req, res } = context;
  const url = req ? getUrlFromRequest(req) : getWindowUrl();

  const currentOrigin = getOriginWithPrefix(url);
  const targetOrigin = getTargetOrigin(url, 'fashionunited.info');

  if (currentOrigin !== targetOrigin) {
    redirectToDomain(
      '/international-network',
      res,
      targetOrigin,
    );
  }

  return {};
};

export default InternationalNetworkPage;
